import { render, staticRenderFns } from "./createOrder.vue?vue&type=template&id=2cabe6f6&scoped=true"
import script from "./createOrder.vue?vue&type=script&lang=js"
export * from "./createOrder.vue?vue&type=script&lang=js"
import style0 from "./createOrder.vue?vue&type=style&index=0&id=2cabe6f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cabe6f6",
  null
  
)

export default component.exports